import { createSelector } from 'redux-starter-kit';
const advisorSelector = (state: any) => state.advisor;

export const advisorSelectors = {
  getAdvisor: createSelector(advisorSelector, subState => subState.advisor),
  isFirmAdmin: createSelector(
    advisorSelector,
    subState => subState.advisor.firm_admin
  ),
  canSeeMultipleAdvisors: createSelector(
    advisorSelector,
    subState =>
      subState.advisor.firm_admin ||
      (subState.advisor.access_level === 'Adviser'
        ? subState.advisor.client_visibility === 2
        : subState.advisor.advisers?.length > 1)
  ),
  availableAdvisors: createSelector(
    advisorSelector,
    subState => subState.advisor.advisers
  )
};
